import { render, staticRenderFns } from "./EvaluacionRespetoPrincipiosDialogComponent.vue?vue&type=template&id=155f1cff"
import script from "./EvaluacionRespetoPrincipiosDialogComponent.vue?vue&type=script&lang=js"
export * from "./EvaluacionRespetoPrincipiosDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports